import { AxiosError } from "axios"
import { ErrorType } from "@/shared/types"

const statusMessages: Record<number, string> = {
    400: "Проверьте правильность заполнения полей",
    401: "Сессия истекла, войдите заново",
    403: "Недостаточно прав",
    404: "Меню не найдено",
    409: "Меню с такими параметрами уже существует",
    502: "Сервис меню ресторанов временно недоступен. Повторите попытку позже",
    503: "Сервис меню ресторанов временно недоступен. Повторите попытку позже",
    504: "Сервис меню ресторанов временно недоступен. Повторите попытку позже",
}

const isUnavailableStatus = (status?: number): boolean => {
    return status === 502 || status === 503 || status === 504
}

export const getApiErrorMessage = (error: unknown): string => {
    const knownError = error as AxiosError<ErrorType>
    const serverMessage = knownError.response?.data?.message

    if (serverMessage && !isUnavailableStatus(knownError.response?.status)) {
        return serverMessage
    }

    const status = knownError.response?.status
    if (status && statusMessages[status]) {
        return statusMessages[status]
    }

    if (!knownError.response) {
        return "Не удалось связаться с сервером. Проверьте соединение и повторите попытку"
    }

    return "Произошла непредвиденная ошибка"
}
